import { isNullOrUndefined } from '@bimser/core';

export interface ISize {
	width: number;
	height?: number;
}

export const CovertSizeToCSS = function (size: ISize, defaultValues?: ISize) {
	size = {
		...(defaultValues || {}),
		...size
	};

	return {
		width: !CheckSize(size.width) ? size.width + 'px' : '',
		height: !CheckSize(size.height) ? size.height + 'px' : ''
	};
};

export const CheckSize = (height: number) => isNullOrUndefined(height) || Number(height) === 0;
